import api from '@/libs/axios'

export default {
  getLogbooks: () => api.get('/system/logbook'),
  getLogbookById: id => api.get(`/system/logbook/${id}`),
  editLogbook: form => api.patch(`/system/logbook/${form.id}`, form),
  createLogbook: form => api.post('/system/logbook', form),
  deleteLogbook: array => api.delete('/system/logbook', array),
}
